import React from 'react'
import HomePage from '../containers/HomePage'

const Home = () => {
  return (
    <>
      <HomePage/>
    </>
  )
}

export default Home